import '@polymer/polymer/polymer-legacy.js';
import '@polymer/paper-ripple/paper-ripple.js';
import '@polymer/iron-icons/device-icons.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/flex.js';
import '../style-modules/paper-table-style.js';
import '../katapult-drop-down/katapult-drop-down.js';
import '../user-chip/user-chip.js';
import '../paper-table/paper-table.js';
import AppName from '../../app-configuration/appName.js';
import { config } from '../../app-configuration/config.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { checkIsDevelopmentOrigin, checkIsInternalOrigin } from '../../modules/CheckOrigin.js';
import { GetCompanyNames } from '../../modules/GetCompanyNames.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '../feedback/feedback-element.js';
import '../katapult-elements/searchable-dropdown.js';
import { html as litHtml } from 'lit';
import { logger } from '@sentry/browser';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';

class LoginChip extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-dialog-style flex paper-table-style">
        :host {
          position: relative;
        }
        #chip {
          flex-shrink: 0;
          @apply --user-chip;
        }
        #chip:hover {
          cursor: pointer;
        }
        #menu {
          display: flex;
          flex-direction: column;
          background: var(--sl-color-neutral-0);
          box-shadow: var(--sl-shadow-large);
          border-radius: var(--sl-border-radius-large);
          gap: var(--sl-spacing-small);
          padding: var(--sl-spacing-small);
          box-sizing: border-box;
          @apply --login-chip-menu;
          max-height: var(--auto-size-available-height);
          max-width: 100vw;
          overflow-y: auto;
        }
        #largeChip {
          height: 56px;
          --user-chip-profile: {
            height: 48px;
            width: 48px;
            font-size: 18pt;
          };
          --user-chip-name: {
            font-size: 12pt;
            margin-left: 12px;
          };
        }
        .buttons {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: var(--sl-spacing-x-small);
        }
        .notificationDot {
          position: absolute;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          top: 0;
          right: 0;
          border-radius: 14px;
          color: white;
          margin: 0;
          z-index: 1;
          padding-top: 2px;
          text-align: center;
          font-size: 11px;
          pointer-events: none;
          transition: all 0.2s ease;
        }
        paper-spinner-lite {
          --paper-spinner-color: var(--secondary-color);
        }
        feedback-element {
          width: 600px;
          max-width: -webkit-fill-available;
          overflow: hidden;
        }
      </style>
      <firebase-auth id="auth" provider="password" signed-in="{{signedIn}}" status-known="{{statusKnown}}" user="{{user}}"> </firebase-auth>
      <katapult-firebase-worker
        id="individualPermissions"
        path="user_groups/[[user.uid]]/individual_permissions"
        data="{{permissions}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="showNotifications"
        path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/show_notifications"
        data="{{showNotifications}}"
      ></katapult-firebase-worker>

      <katapult-dialog id="changeActiveCompanyWarningDialog" title="Change Active Company" color="var(--sl-color-warning)">
        <span
          >Are you sure you want to change your Active Company? This will remove all currently stored offline jobs and will reload any other
          tabs of Katapult Pro Mobile you have open.
        </span>
        <katapult-button
          slot="buttons"
          on-touchstart="cancelChangeActiveCompanyWarningDialog"
          on-mousedown="cancelChangeActiveCompanyWarningDialog"
          >Cancel</katapult-button
        >
        <katapult-button
          slot="buttons"
          color="var(--sl-color-warning)"
          on-touchstart="mobileChangeActiveCompany"
          on-mousedown="mobileChangeActiveCompany"
          >Change Active Company</katapult-button
        >
      </katapult-dialog>
      <paper-dialog id="waitingDialog" no-cancel-on-esc-key no-cancel-on-outside-click>
        <div title grey>[[waitingDialogOptions.title]]</div>
        <div body style="font-size: 12pt;">
          <paper-row>
            <paper-cell center>
              <template is="dom-if" if="[[!waitingDialogOptions.callbackRunning]]">
                <template is="dom-if" if="[[!online]]">
                  <span>Waiting for network</span>
                </template>
                <template is="dom-if" if="[[online]]">
                  <span>Waiting for sync to finish</span>
                </template>
              </template>
              <template is="dom-if" if="[[waitingDialogOptions.callbackRunning]]">
                <span>[[waitingDialogOptions.callbackMessage]]</span>
              </template>
            </paper-cell>
          </paper-row>
          <paper-row>
            <paper-cell center>
              <paper-spinner-lite active></paper-spinner-lite>
            </paper-cell>
          </paper-row>
        </div>
        <div buttons>
          <katapult-button outline on-touchstart="cancelWaitingDialog" on-mousedown="cancelWaitingDialog">Cancel</katapult-button>
        </div>
      </paper-dialog>

      <sl-dropdown id="dropdown" hoist on-sl-show="slDropdownChanged" on-sl-hide="slDropdownChanged">
        <div slot="trigger">
          <user-chip
            id="chip"
            hide-name="[[hideName]]"
            email="[[user.email]]"
            initials-only="[[initialsOnly]]"
            email-only="[[emailOnly]]"
            full-email="[[fullEmail]]"
            name="{{name}}"
            on-mouseenter="setIsMouseover"
            on-mouseleave="setIsMouseover"
          ></user-chip>
          <template is="dom-if" if="[[!hideFeedback]]">
            <div
              class="notificationDot"
              style$="background-color: var(--secondary-color); [[getDotStyle('NON', isMouseover, countOfIssues, countOfNonIssues)]]"
            >
              [[countOfNonIssues]]
            </div>
            <div
              class="notificationDot"
              style$="background-color: var(--paper-red-500); [[getDotStyle('ISS', isMouseover, countOfIssues, countOfNonIssues)]]"
            >
              [[countOfIssues]]
            </div>
            <div class="notificationDot" style$="[[getTotalDotStyle(isMouseover, countOfIssues, countOfNonIssues)]]">
              [[countOfNotifications]]
            </div>
          </template>
        </div>
        <div id="menu">
          <user-chip id="largeChip" uid="[[user.uid]]" user-group="[[userGroup]]" email-only="" full-email=""></user-chip>
          <!-- User Buttons -->
          <div class="buttons">
            <template is="dom-if" if="[[showMyAccount]]">
              <template is="dom-if" if="[[signedIn]]">
                <katapult-button callback="myAccount" icon="settings">Account</katapult-button>
              </template>
            </template>
            <katapult-button title="Change Login Status" on-click="signOut" loading="[[signingOut]]" icon="[[getLoginStatusIcon(signedIn)]]"
              >[[getLoginStatusText(signedIn)]]</katapult-button
            >
            <katapult-button title="Toggle Feedback" callback="toggleNotifications" icon="[[getNotificationStatusIcon(showNotifications)]]">
              [[getNotificationStatusText(showNotifications)]]
            </katapult-button>
            <slot name="buttons"></slot>
          </div>
          <!-- Desktop Shoelace Dropdowns -->
          <template is="dom-if" if="[[!isMobile]]" restamp>
            <template is="dom-if" if="[[showDatabaseChooser]]">
              <searchable-dropdown
                label="Database"
                items="[[filteredDatabaseList]]"
                value="[[databaseName]]"
                on-user-input="databaseSwitcherInputHandler"
                on-change="databaseSwitcherChangeHandler"
                disabled="[[switchingDatabase]]"
                render-item="[[databaseChooserRenderItem]]"
                filter-manually
                hoist
              >
                <katapult-icon slot="prefix" icon="database" outline></katapult-icon>
              </searchable-dropdown>
            </template>
            <template is="dom-if" if="[[showCompanySwitcher]]">
              <searchable-dropdown
                label="Active Company"
                items="[[companySwitcherOptions]]"
                value="[[userGroup]]"
                on-change="changeActiveCompany"
                disabled="[[companySwitcherDisabled]]"
                hoist
              >
                <katapult-icon slot="prefix" icon="business" outline></katapult-icon>
              </searchable-dropdown>
            </template>
          </template>
          <!-- Traditional Katapult Drop Downs -->
          <template is="dom-if" if="[[isMobile]]" restamp>
            <template is="dom-if" if="[[or(showDatabaseChooser, showCompanySwitcher)]]">
              <!-- Database and Company Chooser -->
              <paper-table rounded outline>
                <template is="dom-if" if="[[showDatabaseChooser]]">
                  <paper-row style="padding: 0 10px; align-items: center; height: unset;">
                    <iron-icon icon="device:storage" style="margin-right: 10px;"></iron-icon>
                    <katapult-drop-down
                      id="dbSwitcher"
                      label="Database"
                      style="flex: 1;"
                      items="[[databaseList]]"
                      sort="[[sortByLabel]]"
                      value-path="value"
                      label-path="label"
                      secondary-label-path="value"
                      value="[[databaseName]]"
                      on-selected-changed="databaseSwitcherChangeHandler"
                      disabled="[[switchingDatabase]]"
                      no-clear
                    ></katapult-drop-down>
                  </paper-row>
                </template>
                <template is="dom-if" if="[[showCompanySwitcher]]">
                  <paper-row style="padding: 0 10px; align-items: center; height: unset;">
                    <iron-icon icon="communication:business" style="margin-right: 10px;"></iron-icon>
                    <katapult-drop-down
                      label="Active Company"
                      style="flex: 1;"
                      items="[[companySwitcherOptions]]"
                      value="[[userGroup]]"
                      label-path="label"
                      value-path="value"
                      on-selected-changed="changeActiveCompany"
                      disabled="[[activeCompanySwitcherDisabled]]"
                    ></katapult-drop-down>
                  </paper-row>
                </template>
              </paper-table>
            </template>
          </template>
          <!-- Inbox -->
          <template is="dom-if" if="[[showNotifications]]">
            <feedback-element inbox></feedback-element>
          </template>
        </div>
      </sl-dropdown>
    `;
  }

  static get is() {
    return 'login-chip';
  }

  static get properties() {
    return {
      companyList: {
        type: Array,
        value: () => []
      },
      companyNameCache: {
        type: Object,
        value: {}
      },
      hideName: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      hideFeedback: {
        type: Boolean,
        value: false
      },
      userGroup: {
        type: String,
        value: null
      },
      user: {
        type: Object,
        value: null,
        notify: true
      },
      initialsOnly: {
        type: Boolean,
        value: false
      },
      emailOnly: {
        type: Boolean,
        value: false
      },
      fullEmail: {
        type: Boolean,
        value: false
      },
      name: {
        type: String,
        notify: true
      },
      horizontalAlign: {
        type: String,
        value: 'center'
      },
      horizontalOffset: {
        type: Number,
        value: 0
      },
      hideDatabaseChooser: {
        type: Boolean,
        value: false
      },
      showDatabaseChooser: {
        type: Boolean,
        computed: 'shouldShowDatabaseChooser(user.email, hideDatabaseChooser)'
      },
      signedIn: {
        type: Boolean,
        value: false,
        notify: true
      },
      statusKnown: {
        type: Boolean,
        value: false,
        notify: true
      },
      unreadConversationsCount: {
        type: Number,
        value: null
      },
      verticalAlign: {
        type: String,
        value: 'top'
      },
      verticalOffset: {
        type: Number,
        value: 48
      },
      databaseList: {
        type: Array
      },
      countOfNotifications: {
        type: Number,
        computed: 'sum(countOfIssues, countOfNonIssues)'
      },
      companySwitcherDisabled: {
        type: Number,
        computed: 'computeCompanySwitcherDisabled(changingActiveCompany, companySwitcherOptions)'
      },
      opened: {
        type: Boolean,
        value: false
      },
      showCompanySwitcher: {
        type: Boolean,
        computed: 'greaterThan(companyList.length, 1)'
      }
    };
  }

  constructor() {
    super();
    const fullDatabaseList = Object.entries(config?.firebaseConfigs ?? {})
      .map(([key, { label }]) => ({ value: key, label }))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    this.filteredDatabaseList = this.databaseList = fullDatabaseList.filter((x) => x.value !== 'beta-katapult-pro');

    // Property initializations
    this.permissions = {};
    this.companyNameCache = {};

    // Template helpers
    this.sum = (...values) => values.reduce((acc, x) => (acc += parseInt(x)), 0);
    this.greaterThan = (a, b) => a > b;
    this.sortByLabel = (a, b) => {
      let input = this.shadowRoot.querySelector('#dbSwitcher').searchText;
      const exactMatch = a.label.toUpperCase() == input.toUpperCase(); //if a db common name matches the search term exactly
      const partLabelMatch = a.label.toUpperCase().includes(input.toUpperCase()) && !b.label.toUpperCase().includes(input.toUpperCase()); //if a db common name matches the search term partially
      const partValMatch = a.value.toUpperCase().includes(input.toUpperCase()) && !b.value.toUpperCase().includes(input.toUpperCase()); //if a db technical name matches the search term partially
      if (exactMatch || partLabelMatch || partValMatch) return -1; //'a' takes priority over 'b'
      return a.label.localeCompare(b.label); //otherwise, sort alphabetically by common name
    };
    this.or = (...args) => args.some((x) => !!x);
    this.databaseChooserRenderItem = (item) => litHtml`
      <sl-menu-item value=${item.value}>
        <div style="display: flex; flex-direction: column; margin: var(--sl-spacing-x-small) 0;">
          <span>${item.label}</span>
          <span style="font-size: var(--sl-font-size-small); font-weight: var(--sl-font-weight-semibold);">${item.value}</span>
        </div>
      </sl-menu-item>
    `;
  }

  static get observers() {
    return [
      'updateFeedbackQueueListener(userGroup, user.*)',
      'updateCompanyList(opened, permissions.*, userGroup)',
      'updateCompanySwitcherOptions(companyList)'
    ];
  }

  ready() {
    super.ready();
    this.databaseName = config && config.appName;
    firebase
      .database()
      .ref('.info/connected')
      .on('value', (s) => {
        this.online = s.val();
      });
    this.or = (...args) => args.some((x) => !!x);
    this.isMobile = self.isMobile;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Unsubscribe from any existing listeners
    if (this.feedbackQueueListenerUnsub) this.feedbackQueueListenerUnsub();
  }

  updateCompanySwitcherOptions() {
    const { companyList } = this;
    if (!Array.isArray(companyList)) this.companySwitcherOptions = [];
    else {
      const options = companyList.filter((x) => x.visible).map((x) => ({ label: x.name || x.$key, value: x.$key }));
      options.sort((a, b) => a.label.localeCompare(b.label));
      this.companySwitcherOptions = options;
    }
  }

  databaseSwitcherInputHandler(e) {
    const searchString = e.detail.value;
    const sanitizedSearchString = searchString.trim().toLowerCase();
    const uppercaseSanitizedSearchString = sanitizedSearchString.toUpperCase();

    const filteredDatabaseList = this.databaseList.filter((item) => {
      // Check if the item label or value contains the search string
      const labelMatch = item.label.toLowerCase().includes(sanitizedSearchString);
      const valueMatch = item.value.toLowerCase().includes(sanitizedSearchString);
      // Return true if either matches
      return labelMatch || valueMatch;
    });

    const filteredSortedDatabaseList = filteredDatabaseList.sort((a, b) => {
      const exactMatch = a.label.toUpperCase() == uppercaseSanitizedSearchString; //if a db common name matches the search term exactly
      const partLabelMatch =
        a.label.toUpperCase().includes(uppercaseSanitizedSearchString) && !b.label.toUpperCase().includes(uppercaseSanitizedSearchString); //if a db common name matches the search term partially
      const partValMatch =
        a.value.toUpperCase().includes(uppercaseSanitizedSearchString) && !b.value.toUpperCase().includes(uppercaseSanitizedSearchString); //if a db technical name matches the search term partially
      if (exactMatch || partLabelMatch || partValMatch) return -1; //'a' takes priority over 'b'
      return a.label.localeCompare(b.label); //otherwise, sort alphabetically by common name
    });

    this.filteredDatabaseList = filteredSortedDatabaseList;
  }

  cancelWaitingDialog() {
    this.cancelCallbackWhenSynced();
  }

  cancelChangeActiveCompanyWarningDialog() {
    // change the active company drop down back to the previous company
    this.mobileChangeActiveCompanyOptions.dropdown.value = this.mobileChangeActiveCompanyOptions.prevCompanyId;
    // Close the dialog and clear the options
    this.mobileChangeActiveCompanyOptions = {};
    this.$.changeActiveCompanyWarningDialog.close();
  }

  async runCallbackWhenSynced(options = {}) {
    this.waitingDialogOptions = {
      title: options.title,
      callbackMessage: options.callbackMessage,
      callbackRunning: false
    };
    let error;
    let success = false;
    try {
      // Open the dialog.
      this.$.waitingDialog.open();
      // Create a canceled flag
      let canceled = false;
      if (self.isMobile) {
        // Block firebase writes.
        FirebaseWorker.blockWrites(true);
        // Wait for existing writes to finish or user cancellation.
        await Promise.race([
          Promise.all([FirebaseWorker.promises.unsavedChanges, FirebaseWorker.promises.synced]),
          new Promise((x) => (this.cancelCallbackWhenSynced = x)).finally(() => (canceled = true))
        ]);
      }
      if (!canceled) {
        // Update the callback running flag.
        this.set('waitingDialogOptions.callbackRunning', true);
        // Call to auth element to refresh session token
        if (options.companyId) {
          await katapultAuth?.requestUpdatedClaims(options.companyId);
        }
        // Run the callback.
        await options.callback();
        // Set success flag.
        success = true;
      }
    } catch (err) {
      error = err;
    }
    // Clear the callback running flag.
    this.set('waitingDialogOptions.callbackRunning', false);
    if (self.isMobile) {
      // Unblock firebase writes.
      FirebaseWorker.blockWrites(false);
    }
    // Close the dialog.
    this.$.waitingDialog.close();
    // Throw the error again.
    if (error) throw error;
    // Return whether the callback ran or not.
    return success;
  }

  async databaseSwitcherChangeHandler(e) {
    // Get a reference to the selected database.
    const input = e.target;
    let database = input.value;
    let prevDatabase = this.databaseName;
    // Set the switching flag.
    this.switchingDatabase = true;
    let success = await this.runCallbackWhenSynced({
      title: 'Switch Database',
      callbackMessage: 'Switching Databases',
      callback: async () => {
        if (self.isMobile) {
          await FirebaseWorker.clearOfflinePathDirectory().then((res) => {
            this.clearMobileJobandCachedJobs();
          });
        }
        AppName.set(database);
        window.location.href = window.location.origin + window.location.pathname;
      }
    });
    if (!success) input.value = prevDatabase;
    // Clear the swiching flag.
    this.switchingDatabase = false;
  }

  getDotStyle(dotId, isMouseover, countOfIssues, countOfNonIssues) {
    if (dotId == 'ISS') {
      if (isMouseover && countOfIssues && countOfNonIssues) return `top: -6px; right: 6px;`;
      else if (countOfIssues && !countOfNonIssues) return '';
    } else if (dotId == 'NON') {
      if (isMouseover && countOfIssues && countOfNonIssues) return `top: 6px; right: -6px;`;
      else if (countOfNonIssues && !countOfIssues) return '';
    }
    return 'opacity: 0;';
  }

  getTotalDotStyle(isMouseover, countOfIssues, countOfNonIssues) {
    if (isMouseover) return 'opacity: 0;';
    if (countOfIssues) return 'background-color: var(--paper-red-500);';
    else if (countOfNonIssues) return 'background-color: var(--secondary-color);';
    else return 'opacity: 0;';
  }

  async changeActiveCompany(e) {
    // TODO: maybe this should run also when an external change to the active company is made?
    let dropdown = e.currentTarget;
    let companyId = dropdown.value;
    let prevCompanyId = this.userGroup;
    if (companyId == prevCompanyId) return;
    let uid = this.user?.uid;
    // If this isn't mobile, don't actually do anything with firebase options.
    let firebaseParams = [companyId];
    if (self.isMobile) firebaseParams.push(undefined, { ignoreBlockWrites: true });
    // Make sure a company has been selected and we have the user's uid.
    if (companyId && uid) {
      if (self.isMobile) {
        // Warn the user about what happens when they change active companies
        this.mobileChangeActiveCompanyOptions = {
          dropdown,
          companyId,
          prevCompanyId,
          uid,
          firebaseParams
        };
        this.$.changeActiveCompanyWarningDialog.open();
      } else {
        // Set changing active company flag.
        this.changingActiveCompany = true;
        let success = await this.runCallbackWhenSynced({
          companyId,
          title: 'Switch Company',
          callbackMessage: 'Switching Companies',
          callback: async () => {
            FirebaseWorker.ref(`user_groups/${uid}/permissions/photoheight`).set(...firebaseParams);
          }
        });
        // If we didn't switch companies, reset the dropdown to the user group.
        if (!success) dropdown.value = prevCompanyId;
        // Clear changing company flag.
        this.changingActiveCompany = false;
      }
    }
  }

  async mobileChangeActiveCompany() {
    // close the dialog
    this.$.changeActiveCompanyWarningDialog.close();
    let options = this.mobileChangeActiveCompanyOptions;
    // Set changing active company flag.
    this.changingActiveCompany = true;
    let success = await this.runCallbackWhenSynced({
      companyId: options.companyId,
      title: 'Switch Company',
      callbackMessage: 'Switching Companies',
      callback: async () => {
        await FirebaseWorker.activeCompanyChanged(options.companyId);
        this.clearMobileJobandCachedJobs();
        FirebaseWorker.ref(`user_groups/${options.uid}/permissions/photoheight`).set(...options.firebaseParams);
      }
    });
    // If we didn't switch companies, reset the dropdown to the user group.
    if (!success) options.dropdown.value = options.prevCompanyId;
    // Clear changing company flag.
    this.changingActiveCompany = false;
  }

  clearMobileJobandCachedJobs() {
    // set katapult-maps-mobile jobChooserJobId to ''
    if (this.__dataHost?.jobChooserJobId !== undefined) this.__dataHost.jobChooserJobId = '';

    // clear local storage for cachedJobs
    if (this.__dataHost?.$?.offlineManager?.cachedJobs !== undefined) this.__dataHost.$.offlineManager.cachedJobs = [];
  }

  myAccount() {
    if (window.katapultAuth) window.katapultAuth.openMyAccount();
  }

  slDropdownChanged(e) {
    this.opened = e.currentTarget?.open ?? false;
    if (this.userGroup == '_custom_auth') this.showMyAccount = false;
    if (this.showMyAccount == null) {
      this.showMyAccount = window.katapultAuth != null;
    }
  }

  setIsMouseover(e) {
    this.isMouseover = e.type == 'mouseenter' ? true : false;
  }

  shouldShowDatabaseChooser(email, hideDatabaseChooser) {
    return (
      !hideDatabaseChooser &&
      (checkIsDevelopmentOrigin() || checkIsInternalOrigin()) &&
      email != null &&
      email.toLowerCase().indexOf('training') == -1
    );
  }

  async signOut() {
    if (this.signedIn) {
      // Show a confirm dialog when signing out of mobile to make sure users know they will lose cached jobs
      if (self.isMobile) {
        const confirmDialog = KatapultDialog.confirm({
          text: `Are you sure you want to sign out? This will remove all currently stored offline jobs.`,
          dialog: { title: 'Sign Out', color: 'var(--sl-color-warning)' },
          confirmButton: { label: 'Sign out' }
        });
        // Don't sign out if the user cancels the confirm dialog
        const confirmed = await confirmDialog.confirmed;
        if (!confirmed) return;
      }

      this.signingOut = true;
      let success = await this.runCallbackWhenSynced({
        title: 'Sign Out',
        callbackMessage: 'Signing Out',
        callback: async () => {
          if (self.isMobile) {
            await FirebaseWorker.clearOfflinePathDirectory(true).then((res) => {
              this.clearMobileJobandCachedJobs();
            });
          }
          this.$.auth.signOut();
        }
      });
      if (success) this.dispatchEvent(new CustomEvent('sign-out', { bubbles: true, composed: true }));
      this.closeMenu();
      this.signingOut = false;
    } else {
      katapultAuth.showSignIn = true;
    }

    // Track sign out action
    logger.info('Signed out manually from user chip');
  }

  stopPropagation(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  async updateCompanyList() {
    if (!this.opened) return;

    const realtimeDB = globalThis.FirebaseWorker.database();

    // If the user only has access to one company, then their
    // switcher will not appear, so don't try to fetch companies
    const permissions = Object.keys(this.permissions ?? {});
    if (permissions.length < 2) {
      this.companyList = [];
      return;
    }

    // Get the company list
    this.companyList = await Promise.all(
      permissions.map(async (companyId) => {
        const hasCacheRecord = this.companyNameCache[companyId] != null;

        // If the company was not in the cache, add it
        if (!hasCacheRecord) {
          const companyNames = await GetCompanyNames({ [companyId]: true });
          const name = companyNames[companyId];
          let visible = true;
          // The user's root company should not be visible if it was auto added for CSI
          if (companyId == katapultAuth?.rootCompany)
            visible = (await realtimeDB.ref(`photoheight/company_space/${companyId}/auto_added_for_csi`).once('value')).val() !== true;
          this.companyNameCache[companyId] = { name, visible };
        }

        // Pull the name and visibility from the cache (which is now guaranteed to exist)
        const { name, visible } = this.companyNameCache[companyId];

        return { $key: companyId, name, visible };
      })
    );
  }

  computeCompanySwitcherDisabled(changingActiveCompany, companySwitcherOptions) {
    return changingActiveCompany || companySwitcherOptions?.length < 2;
  }

  updateFeedbackQueueListener() {
    // Detach any existing listeners
    if (this.feedbackQueueListenerUnsub) this.feedbackQueueListenerUnsub();

    // If we have user data, set up the listener
    if (this.user?.uid && this.userGroup && this.userGroup != '_custom_auth') {
      const feedbackQueueQuery = firebase
        .firestore()
        .collection(`companies/${this.userGroup}/feedback`)
        .where('queued_for', 'array-contains', this.user.uid);
      // On each snapshot, get new counts
      this.feedbackQueueListenerUnsub = feedbackQueueQuery.onSnapshot((s) => {
        const previousCountOfIssues = this.countOfIssues,
          previousCountOfNonIssues = this.countOfNonIssues;
        this.countOfIssues = s.docs.filter((x) => x.data().issue_status == 'UNRESOLVED').length;
        this.countOfNonIssues = s.size - this.countOfIssues;

        // Fire a notification if permission granted and not on page-load
        if (this._notificationsEnabled() && this._feedbackQueueLoadedOnce) {
          if (previousCountOfIssues < this.countOfIssues) {
            // Fire a notification (limit one per 5 seconds)
            new Notification('You have new unresolved feedback', { tag: `ISS_${Math.floor(Date.now() / 5000)}` });
          } else if (previousCountOfNonIssues < this.countOfNonIssues) {
            // Fire a notification (limit one per 5 seconds)
            new Notification('You have a new unread message', { tag: `NON_${Math.floor(Date.now() / 5000)}` });
          }
        }
        this._feedbackQueueLoadedOnce = true;
      });
    } else {
      this.countOfIssues = 0;
      this.countOfNonIssues = 0;
      this._feedbackQueueLoadedOnce = false;
    }
  }

  _notificationsEnabled() {
    return 'Notification' in window && Notification.permission == 'granted';
  }

  async toggleNotifications() {
    if (!this.userGroup || !this.user?.uid) return;
    const currentShowNotifications = this.showNotifications ?? false;
    const newShowNotifications = !currentShowNotifications;
    const notificationEnabledRef = FirebaseWorker.ref(
      `photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/show_notifications`
    );
    await notificationEnabledRef.set(newShowNotifications);

    // Track toggle notifications action
    logger.info('Toggled showing feedback on user chip', { value: newShowNotifications });
  }

  getLoginStatusIcon(signedIn) {
    return signedIn ? 'logout' : 'login';
  }

  getLoginStatusText(signedIn) {
    return signedIn ? 'Sign Out' : 'Sign In';
  }

  getNotificationStatusIcon(showNotifications) {
    return showNotifications ? 'cancel' : 'question_answer';
  }

  getNotificationStatusText(showNotifications) {
    return showNotifications ? 'Hide Feedback' : 'Show Feedback';
  }
  closeMenu() {
    this.$.dropdown.hide();
  }
}
window.customElements.define(LoginChip.is, LoginChip);
